export type EditConfiguracaoComunicadoProperty =
  | "SET_CONFIGURACAO_COMUNICADO"
  | "UNSET_CONFIGURACAO_COMUNICADO"
  | "SET_DESCRICAO"
  | "SET_DATA"
  | "SET_VENCIMENTO"
  | "SET_ATIVO"
  | "SET_DADOS_FIADOR_ATIVO"
  | "SET_NOME_ARQUIVO"
  | "SET_BOLETOS"
  | "SET_SHOPPINGS"
  | "SET_TIPO_COMUNICADO"
  | "SET_TIPO_DIVIDA"
  | "SET_TIPO_CANAL";

export const INITIAL_STATE = {
  idComunicado: undefined,
  descricaoComunicado: "",
  idCanal: undefined,
  idTipoDivida: undefined,
  idTipoComunicado: undefined,
  flagAtivo: true,
  shoppings: [],

  flagDadosTitulo: false,
  flagDadosFiador: false,

  quantidadeMinimaBoletos: 1,
  nomeArquivo: "",
  mascaraData: "dd/MM/yyyy",
  parametroVencimento: "",
};

export function reducer(
  state: any,
  { type, payload }: { type: EditConfiguracaoComunicadoProperty; payload?: any }
): any {
  switch (type) {
    case "SET_CONFIGURACAO_COMUNICADO":
      return {
        ...payload,
      };
    case "UNSET_CONFIGURACAO_COMUNICADO":
      return undefined;
    case "SET_DESCRICAO":
      return {
        ...state,
        descricaoComunicado: payload,
      };
    case "SET_DATA":
      return {
        ...state,
        mascaraData: payload,
      };
    case "SET_VENCIMENTO":
      return {
        ...state,
        parametroVencimento: payload,
      };
    case "SET_ATIVO":
      return {
        ...state,
        flagAtivo: payload,
      };
    case "SET_DADOS_FIADOR_ATIVO":
      return {
        ...state,
        flagDadosFiador: payload,
      };
    case "SET_NOME_ARQUIVO":
      return {
        ...state,
        nomeArquivo: payload,
      };
    case "SET_BOLETOS":
      return {
        ...state,
        quantidadeMinimaBoletos: payload,
      };
    case "SET_SHOPPINGS":
      return {
        ...state,
        shoppings: payload,
      };
    case "SET_TIPO_CANAL":
      return {
        ...state,
        idCanal: payload,
      };
    case "SET_TIPO_DIVIDA":
      return {
        ...state,
        idTipoDivida: payload,
      };
    case "SET_TIPO_COMUNICADO":
      return {
        ...state,
        idTipoComunicado: payload,
      };
    default:
      return state;
  }
}
